export const articleType = {
  PROPERTY: 'PROPERTY',
  BOOKING: 'BOOKING',
  PAYMENT: 'PAYMENT',
};

export const articleStatusType = {
  NEW: 'NEW',
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export const articleContentType = {
  TITLE: 'TITLE',
  SUBTITLE: 'SUBTITLE',
  TEXTAREA: 'TEXTAREA',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
};